module.exports = __webpack_public_path__ + "static/img/img-common-icon.11ee35a2.png";